/* eslint-disable import/extensions */
import * as React from 'react'

import { FieldProps, getIn } from 'formik'

import {
  KeyboardDatePicker as MuiKeyboardDatePicker,
  KeyboardDatePickerProps as MuiKeyboardDatePickerProps,
} from '@material-ui/pickers'

import { INVALID_DATE, MIN_AGE_ERROR } from '../Forms.ErrorMessages'

export interface KeyboardDatePickerProps
  extends FieldProps,
    Omit<MuiKeyboardDatePickerProps, 'name' | 'value' | 'error' | 'onChange'> {}

export default function KeyboardDatePicker({
  children,
  disabled,
  field,
  helperText,
  form: { isSubmitting, touched, errors, status = {}, setFieldValue, setFieldError },
  ...props
}: KeyboardDatePickerProps) {
  const fieldError =
    (getIn(touched, field.name) || field.value) &&
    (getIn(errors, field.name) || status[field.name]?.errors)

  const fieldErrorMsg = (fieldError || '').includes('Invalid') ? INVALID_DATE : fieldError

  const fieldProps: MuiKeyboardDatePickerProps = {
    ...props,
    ...field,
    error: !!fieldError,
    helperText: fieldErrorMsg ?? helperText,
    disabled: disabled !== undefined ? disabled : isSubmitting,
    onChange(date) {
      setFieldValue(field.name, date)
    },
    onError(error) {
      if (error !== fieldError && !(error === '' && !fieldError)) {
        if (error) {
          setFieldError(field.name, String(error))
        }
      }
    },
  }
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <MuiKeyboardDatePicker {...fieldProps} minDateMessage={MIN_AGE_ERROR} data-hook={field.name}>
      {children}
    </MuiKeyboardDatePicker>
  )
}
